<template>
  <div class="zcbody" v-loading="loading">
    <div class="contanerpric minprict">
      <el-card class="box-card boxcard">
        <div slot="header" class="clearfix clearheader">
          <b>预中标描述</b>
          <div class="pull-right">
            <el-button type="primary" size="mini" @click="SetInquiryAward()"
              >再次报价</el-button
            >
            <el-button type="primary" size="mini" @click="SetInquiryAward()"
              >开标</el-button
            >
            <el-button type="primary" size="mini" @click="SetInquiryAward()"
              >开标结束</el-button
            >
          </div>
        </div>
        <el-row class="rowdig">
          <el-col :span="6" class="infodata1">
            <span><b>项目编号:</b></span> <span>{{ dt.cprocode }}</span>
          </el-col>
          <el-col :span="6" class="infodata1">
            <span><b>项目名称:</b></span> <span>{{ dt.cproname }}</span>
          </el-col>
          <el-col :span="6" class="infodata1">
            <span><b>公告日期:</b></span> <span>{{ dt.dprodate }}</span>
          </el-col>
          <el-col :span="6" class="infodata1">
            <span><b>开标方式:</b></span> <span>{{ dt.copentype }}</span>
          </el-col>
          <el-col :span="6" class="infodata1">
            <span><b>是否讲标:</b></span> <span>{{ dt.cisspeak }}</span>
          </el-col>
          <!-- 未改字段 -->
          <el-col :span="6" class="infodata1">
            <span><b>报价截止日期:</b></span> <span>{{ dt.denddate }}</span>
          </el-col>

          <el-col :span="6" class="infodata1">
            <span><b>开标时间:</b></span> <span>{{ dt.dopendate }}</span>
          </el-col>
          <el-col :span="24" class="infodata1" style="">
            <span><b style="float: left">预中标描述:</b></span>
            <span>
              <el-input
                v-model="dt.cdescribe"
                type="textarea"
                rows="5"
                placeholder="预中标描述"
                style="width: 80%"
              ></el-input>
            </span>
          </el-col>
        </el-row>
      </el-card>
      <el-card class="box-card boxcard">
        <div slot="header" class="clearfix">
          <i class="el-icon-s-unfold"></i><b>厂商应标信息</b>
        </div>

        <yingbiao
          ref="rendsref"
          @rend="rend"
          :dt2table1="tablelist0"
          :urlid="urlid"
        />
        <!-- 可以使用span 和 span-map对象来控制栅格的大小 -->
      </el-card>
      <el-card class="box-card boxcard">
        <div slot="header" class="clearfix">
          <i class="el-icon-s-unfold"></i><b>厂商报价信息</b>
        </div>
        <tablerends
          ref="rendsref"
          :dt="dt"
          :dt2list1="dt2list1"
          @rend="rend"
          :dt2list="dt2list"
          :dt2table1="tablelist0"
          :cop="cop"
          :tableHead="tableHead"
          :urlid="urlid"
        />
        <!-- 可以使用span 和 span-map对象来控制栅格的大小 -->
      </el-card>
      <el-card class="box-card boxcard">
        <div slot="header" class="clearfix">
          <i class="el-icon-s-unfold"></i><b>厂商综合评分</b>
        </div>
        <tablepingjia
          ref="rendsref"
          :dt="dt"
          :dt2list1="dt2list1"
          @rend="rend"
          :dt2list="dt2list"
          :dt2table1="tablelist0"
          :cop="cop"
          :tableHead="tableHead"
          :urlid="urlid"
        />
        <!-- 可以使用span 和 span-map对象来控制栅格的大小 -->
      </el-card>
      <zpin :dt3="dt3" :dt4="dt4" :dt5="dt5" />
    </div>
  </div>
</template>

<script>
// import { set } from "vue/types/umd";
import tablerends from "./tabletrends.vue";
import tablepingjia from "./toubiao/tablepingjia.vue";
import yingbiao from "./yingbiao.vue";
import zpin from "./zpin.vue";
export default {
  components: {
    tablerends,
    zpin,
    yingbiao,
    tablepingjia,
  },
  data () {
    return {
      dt: {
        cprocode: "",
        cproname: "",
        dprodate: "",
        copentype: "",
        cisspeak: "",
        denddate: "",
        dopendate: "",
        cdescribe: "",
      },
      dt2: {},
      dt3: [],
      dt4: [],
      dt5: [],
      dt2list1: [],
      dt2list: [],
      urlid: "",
      cop: "",
      loading: false,
      tableHead: [],
      tablelist0: [],
    };
  },
  created () {
    this.urlid = this.$route.query.id;
    this.cop = this.$route.query.cop;
    if (this.urlid != "") {
      this.GetLogInfoByCode();
    }
  },
  methods: {
    // 监听授标完成
    rend (val) {
      this.GetLogInfoByCode();
    },
    // 获取基本信息
    GetLogInfoByCode () {
      this.$axios({
        method: "post",
        url: "CommonModule/Op_Supplier/GetLogInfoByCode",
        data: { clogincode: this.cop },
      }).then((res) => {
        console.log(res);

        if (res.data.Success) {
          this.GetInquiryAllInfo();
        } else {
          this.$message.error(res.data.Message);
        }
      });
    },

    // 返回
    returnpage () {
      sessionStorage.removeItem("params");
      this.$router.push({ path: "/pricinglist?cop=" + this.cop });
    },
    // 获取详情
    GetInquiryAllInfo () {
      this.loading = true;
      this.dt = {};
      this.dt2 = [];
      this.dt3 = [];
      this.dt2list1 = [];
      this.dt2list = [];
      this.dt4 = [];
      this.dt5 = [];
      this.$axios({
        method: "post",
        url: "CommonModule/Op_Supplier/GetInquiryAllInfo",
        data: { KeyValue: this.urlid },
      })
        .then((res) => {
          this.loading = false;
          console.log(res, "结果");
          setTimeout(() => {
            if (res.data.Success) {
              this.loading = false;
              this.dt = res.data.Data.dt[0];
              this.dt2 = res.data.Data.dt2;
              this.dt3 = res.data.Data.dt3;
              this.dt2list1 = res.data.Data.dt2.Table1;
              this.dt2list = res.data.Data.dt2.Table;
              this.dt4 = res.data.Data.dt4;
              this.dt5 = res.data.Data.dt5;
              this.arryzli();
            } else {
              this.loading = false;
              this.$message.error(res.data.Message);
            }
          }, 10);
        })
        .catch((error) => {
          this.loading = false;
        });
    },
    arryzli () {
      const res = new Map();
      console.log(this.dt2.Table1);
      this.tableHead = [];
      var tablelist1 = this.dt2.Table1.filter(
        (arr) => !res.has(arr.cvenname) && res.set(arr.cvenname, 1)
      );
      // console.log(tablelist1);
      // var tablehead = [];

      for (var a = 0; a < tablelist1.length; a++) {
        this.tableHead.push({
          label: tablelist1[a].cvenname,
          property: "cvename" + tablelist1[a].cvencode,
          child: [],
        });
      }
      // console.log(this.tableHead);
      var tablelist = this.dt2.Table1;
      var tablelist0 = this.dt2.Table;
      for (var b = 0; b < tablelist.length; b++) {
        tablelist0.forEach((tablistnew) => {
          if (tablelist[b].iautoid == tablistnew.iautoid) {
            this.$set(
              tablistnew,
              "cvename" + tablelist[b].cvencode,
              tablelist[b].iprice
            );
            tablistnew = Object.assign(tablistnew, tablelist[b]);
          }
        });
      }

      this.tablelist0 = tablelist0.filter(
        (arrdt2) => !res.has(arrdt2.iautoid) && res.set(arrdt2.iautoid, 1)
      );
    },
    // 去重
    unique (arr) {
      const res = new Map();
      return arr.filter(
        (arr) => !res.has(arr.cclasscode) && res.set(arr.cclasscode, 1)
      );
    },
  },
};
</script>

<style scoped>
@import url(../../assets/css/reg.css);
</style>

